<template>
    <notifications group="app" :position="position" :duration="5000" :max="max">
    </notifications>
</template>

<script>
    export default {
        props: {
            position: {
                default: 'bottom left'
            },
            max: {
                default: 1
            }
        },

        data() {
            return {
            }
        },

        mounted() {
            console.log('AppNotifications Component Mounted.');

            $('.app-alerts .alert').each((index, el) => {
                let type = 'success';
                if ($(el).hasClass('alert-danger'))     type = 'error';
                if ($(el).hasClass('alert-warning'))    type = 'warn';
                if ($(el).hasClass('alert-info'))       type = 'info';
                this.$notify({group: 'app', text: $(el).find('.alert-body').html(), type, duration: -1, width: 400});
            })
        },

        methods: {

        },
        computed: {

        }
    }
</script>
<style>
    .vdp-datepicker__calendar {
        z-index: 10000000;
        right: 0;
    }
</style>
